import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import {
  discoveryKeys,
  fetchRelatedIdeasByEvidenceIds,
  type RelatedIdeaByEvidence,
} from '../../api/discoveryAgent';

function stableEvidenceIdsKey(ids: string[]): string {
  return [...ids].sort().join(',');
}

export function useRelatedProductFeatures(evidenceIds: string[]) {
  const { getAccessTokenSilently } = useAuth0();
  const key = useMemo(() => stableEvidenceIdsKey(evidenceIds), [evidenceIds]);
  const enabled = evidenceIds.length > 0;

  const query = useQuery({
    queryKey: discoveryKeys.relatedIdeas(key),
    queryFn: async () => {
      const res = await fetchRelatedIdeasByEvidenceIds(evidenceIds, {
        getAccessTokenSilently,
      });
      return res.ideas ?? [];
    },
    enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    ideas: (query.data ?? []) as RelatedIdeaByEvidence[],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
